import React from "react";
import { Link } from "react-router-dom";
import { User, LogOut, ShieldCheck, ChevronDown } from "lucide-react";
import { useAuth, startGoogleLogin } from "../context/AuthContext";
import GoogleSignInButton from "./GoogleSignInButton";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";

const UserMenu = () => {
  const { user, loading, logout } = useAuth();

  if (loading) return <div className="h-9 w-9 rounded-full bg-slate-100 animate-pulse" />;

  if (!user) {
    return <GoogleSignInButton onClick={() => startGoogleLogin("/auth/callback")} className="h-9 px-3 text-xs">Sign in</GoogleSignInButton>;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 rounded-full px-1.5 py-1 hover:bg-slate-100 transition">
          {user.picture ? (
            <img src={user.picture} alt={user.name} referrerPolicy="no-referrer" className="h-8 w-8 rounded-full ring-2 ring-blue-100"/>
          ) : (
            <div className="h-8 w-8 rounded-full bg-gradient-to-br from-blue-500 to-teal-500 grid place-items-center text-white font-semibold text-sm">{(user.name || user.email || "?")[0].toUpperCase()}</div>
          )}
          <span className="hidden lg:block text-sm font-medium text-slate-800 max-w-[120px] truncate">{user.name || user.email}</span>
          <ChevronDown className="h-3.5 w-3.5 text-slate-500 hidden lg:block"/>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="font-normal">
          <div className="font-semibold text-slate-900 text-sm truncate">{user.name || "User"}</div>
          <div className="text-xs text-slate-500 truncate">{user.email}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/account" className="flex items-center gap-2 cursor-pointer"><User className="h-4 w-4"/> My Account</Link>
        </DropdownMenuItem>
        {user.isAdmin && (
          <DropdownMenuItem asChild>
            <Link to="/admin" className="flex items-center gap-2 cursor-pointer text-dl-blue"><ShieldCheck className="h-4 w-4"/> Admin Panel</Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout} className="text-rose-600 cursor-pointer"><LogOut className="h-4 w-4 mr-2"/> Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserMenu;
